import { createSelector } from "reselect"
import { get } from "lodash"
import { getCurrentPerformance } from "./performance"
import { getDisplayCategories } from "./data"
import { getModelCategories } from "selectors/modelMetadata"

export const getOptions = createSelector(
  [getCurrentPerformance, getModelCategories, getDisplayCategories],
  (current, categories, displayCategories) => {
    if (current) {
      const options = [{
        id: "total",
        color: "#00abe8",
        label: "Total",
        value: current.total,
      }, {
        id: "factors",
        color: "#9067a7",
        label: "Factors",
        value: current.factorsTotal,
      },
      ...categories
        .filter(category => !category.singleFactor)
        .map(category => {
          if (!displayCategories[category.id]) return null

          const field = `categories.${category.id}`
          const value = get(current, field)

          return { value, ...category }
        }),
      ]

      // filter out options for which there's no value
      return options.filter(option => option && !Number.isNaN(option.value))
    } else {
      return []
    }
  },
)
